import styles from './input.module.css';

export function Input({
    id,
    label,
    type = "text",
    value,
    error,
    onChange
}){
    return <div className={`${styles.input} ${value ? styles.hasvalue : ''}`}>
        <label htmlFor={id}>{label}</label>
        <input type={type} name={id} id={id} value={value} onChange={onChange} />
    </div>;
}